import { render } from "./DashboardHYU.vue?vue&type=template&id=291cc485&scoped=true"
import script from "./DashboardHYU.vue?vue&type=script&lang=js"
export * from "./DashboardHYU.vue?vue&type=script&lang=js"

import "./DashboardHYU.vue?vue&type=style&index=0&id=291cc485&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291cc485"]])

export default __exports__